export enum SSORole {
  BackofficeAdmin = 'BackofficeAdmin',
  Employee = 'Employee',
  GlobalAdmin = 'GlobalAdmin',
  GroupAdmin = 'GroupAdmin',
}
